import cloudinaryImage from '~/utils/helpers/cloudinaryImage';

export default {
  props: {
    page: {
      type: Object,
      default: () => {},
    },
    subscribed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    postImage() {
      return cloudinaryImage({ imagePath: this.page.post_image, width: 900 });
    },
  },
  methods: {
    moveToForm() {
      document
        .getElementById('subscribe')
        .scrollIntoView({ behavior: 'smooth' });
    },
  },
};
